// Single source of truth for the results list's column widths, shared between the header row
// and each entry row so they can't drift out of alignment with each other. Mirrors the pattern
// used by the Audit Log list (see AuditLog/auditLogConstants.js).
export const TABLE_COLUMNS = {
  id: 'w-16 shrink-0',
  name: 'w-36 shrink-0',
  email: 'flex-1 min-w-0',
  created: 'w-28 shrink-0',
  influencerCreated: 'w-36 shrink-0',
  influencerCreatedAt: 'w-28 shrink-0',
  actions: 'w-32 shrink-0 flex justify-end',
}
